import { render } from "./ModelApartmentsPage.vue?vue&type=template&id=0b0053fd"
import script from "./ModelApartmentsPage.vue?vue&type=script&lang=js"
export * from "./ModelApartmentsPage.vue?vue&type=script&lang=js"

import "./ModelApartmentsPage.vue?vue&type=style&index=0&id=0b0053fd&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__